// ** MUI Imports

// ** Icons Imports
import { Menu as MenuIcon } from 'react-feather'

// ** Type Import
import { Settings } from 'src/@core/context/settingsContext'

// ** Components
// import ModeToggler from 'src/@core/layouts/components/shared-components/ModeToggler'
import UserDropdown from 'src/@core/layouts/components/shared-components/UserDropdown'
import { Link } from '@mui/material'
import { X } from 'react-feather'
import React from 'react'
import StoreSwitcher from 'src/layouts/StoreSwitcher'
import { Popover, PopoverContent, PopoverTrigger } from '@shopflo/ui'
import { FeatureProfile } from 'src/lib/types/random'
import { classNames } from 'src/lib/utils/helpers'
import { useFeatureProfile } from 'src/lib/contexts/FeatureProfileContext'
import { permissionType } from 'src/lib/utils/constants'
import { useUser } from 'src/lib/contexts/UserContext'

interface Props {
  settings: Settings
  toggleNavVisibility: () => void
  hideNavigation?: boolean
}

const AppBarContent = (props: Props) => {
  // ** Props
  const { toggleNavVisibility, hideNavigation = false } = props
  const {
    actions: { switchProfile },
    state: { profile }
  } = useFeatureProfile()
  const { canAccess } = useUser()

  const showSwitcher = canAccess(permissionType.TAB_SSO, 0)

  const products = [
    {
      value: FeatureProfile.SHOPFLO,
      name: 'Shopflo',
      logo: '/images/ShopFloSmall.svg',
      description: 'Checkout and Cart that converts',
      bgColorClass: 'bg-cyan-dark'
    },
    {
      value: FeatureProfile.SHOPPASS,
      name: 'Shop-pass',
      logo: '/images/ShopPassSmall.svg',
      description: 'Identify visitors on your website automatically and retarget them',
      bgColorClass: 'bg-violet-light'
    }
  ]

  const [open, setOpen] = React.useState(false)

  const profileSwitcher = (
    <div className='relative inline-block'>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <div className='p-2 rounded-xl border border-gray-lighter bg-[#FFFFFF1A] cursor-pointer'>
            <img height='24' src='/images/misc/SquaresFour.svg' alt='switch-button' />
          </div>
        </PopoverTrigger>
        <PopoverContent side='bottom' align='start' sideOffset={20} className='bg-white w-[350px] p-2 px-3'>
          <div className='space-y-3'>
            {products.map(product => (
              <div
                onClick={() => {
                  switchProfile(product.value)
                  setOpen(false)
                }}
                key={product.value}
                className={classNames(
                  'flex items-center gap-3 p-2 rounded-lg hover:bg-gray-lightest cursor-pointer',
                  product.value === profile
                    ? 'border border-primary-dark shadow-[0_0_4px_2px] shadow-primary-light'
                    : ''
                )}
              >
                <div
                  className={`min-w-[50px] min-h-[50px] ${product.bgColorClass} rounded-lg flex items-center justify-center`}
                >
                  <img height='24' src={product.logo} alt={`${product.name.toLowerCase()}-logo`} />
                </div>
                <div className='flex flex-col'>
                  <span className='font-semibold text-coal-dark text-base leading-6'>{product.name}</span>
                  <span className='text-sm text-coal-light'>{product.description}</span>
                </div>
              </div>
            ))}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  )

  return (
    <div className='w-full flex items-center justify-between'>
      <div className='actions-left flex items-center gap-4'>
        {showSwitcher && profileSwitcher}
        {!hideNavigation && (
          <button onClick={toggleNavVisibility} className='mr-3.5 text-white block lg:hidden'>
            <MenuIcon fill={'#fff'} />
          </button>
        )}
        <div className='hidden lg:flex items-center gap-4'>
          <Link href='/overview'>
            <img height='24' src='/images/shopflo_logo.svg' alt='shopflo-logo' className='min-w-[100px]' />
          </Link>
          <X className='text-[#949494]' size={14} />
          <StoreSwitcher isDark={false} />
        </div>
      </div>
      <div className='actions-right flex items-center'>
        <UserDropdown />
      </div>
    </div>
  )
}

export default AppBarContent
